import SearchIcon from "@mui/icons-material/Search"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import { SingleServiceCenterDto } from "api"
import { memo } from "react"
import styled from "styled-components"
import { useMapContext } from "../map/MapContext"

const StyledAutocomplete = styled(Autocomplete)`
  .MuiAutocomplete-popupIndicatorOpen {
    transform: rotate(0deg);
  }
`

type CitySearchProps = {
  cities: any[]
  setSelectedCity: any
  className?: string
}

const CitySearch = ({
  cities,
  setSelectedCity,
  className,
}: CitySearchProps) => {
  const { setSelectedStore } = useMapContext<SingleServiceCenterDto>()
  return (
    <div className={className}>
      <StyledAutocomplete
        id="cityAutocomplete"
        popupIcon={<SearchIcon color="primary" />}
        // forcePopupIcon={true}
        options={cities}
        color="primary"
        renderInput={(params) => (
          <TextField {...params} label="חפש עיר" variant="outlined" />
        )}
        autoHighlight
        onChange={(_, value) => {
          setSelectedCity(value)
          setSelectedStore(null)
        }}
      />
    </div>
  )
}

export default memo(CitySearch)
